import "./Layout.css";
import "../../styles/reset.css";
import axios from "axios";
import Header from "../header/Header";
import NoteForm from "../noteForm/noteForm";
import Notes from "../notes/Notes";
import React from "react"

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newNote: {
                title: "",
                text: "",
                color: "",
            },
            notes: [],
            searchInput: "",
        };
    }

    getNotes() {
        axios.get("https://csc-notes.herokuapp.com/api/notes").then((response) => {
            this.setState({
                notes: response.data.data.map((o) => {
                    return {
                        title: o.title,
                        text: o.text,
                        color: o.color,
                        id: o._id,
                        expanded: false,
                    }
                }).reverse()
            });
        });
    }

    componentDidMount() {
        this.getNotes();
    }

    handleInputNewNote = (e) => {
        let newNote = this.state.newNote;
        if (e.target.className === "new-note__title") {
            newNote.title = e.target.value;
        } else {
            newNote.text = e.target.value;
        }
        this.setState({newNote: newNote});
    };

    handleClick = (i) => {
        let notes = this.state.notes.slice();
        notes[i].expanded = true;
        this.setState({notes: notes});
    };

    handleInputForm = (i, e) => {
        const newNotes = this.state.notes.slice();
        if (e.target.className === "new-note__title") {
            newNotes[i].title = e.target.value;
        } else {
            newNotes[i].text = e.target.value;
        }
        this.setState({notes: newNotes});
    };

    handleSubmitNote = (i) => {
        const newNotes = this.state.notes.slice();
        newNotes[i].expanded = false;
        axios.put(`https://csc-notes.herokuapp.com/api/notes/${this.state.notes[i].id}`,
            newNotes[i]
        ).then();
        this.setState({notes: newNotes});
    };

    handleResetNote = (i) => {
        const newNotes = this.state.notes.slice();
        newNotes[i].title = "";
        newNotes[i].text = "";
        newNotes[i].color = "";
        this.setState({notes: newNotes});
    };

    handleResetNewNote = (i) => {
        this.setState({newNote: {
                title: "",
                text: "",
                color: "",
            }
        });
    };

    handleDeleteNote = (i) => {
        let newNotes = this.state.notes.slice();
        newNotes.splice(i, 1);
        this.setState({notes: newNotes});
        axios.delete(`https://csc-notes.herokuapp.com/api/notes/${this.state.notes[i].id}`).then();
    };

    handleSubmitNewNote = async (color) => {
        let newNotes = this.state.notes.slice();
        newNotes.unshift({
            title: this.state.newNote.title,
            text: this.state.newNote.text,
            color: color,
            expanded: false,
        });
        axios.post("https://csc-notes.herokuapp.com/api/notes", this.state.newNote).then();
        this.setState({notes: newNotes, newNote: {title: "", text: "", color: ""}});
    };

    handleClickNoteColor = (i, color) => {
        let newNotes = this.state.notes.slice();
        newNotes[i].color = color;
        this.setState({notes: newNotes});
    };

    handleClickNewNoteColor = (color) => {
        let newNote = this.state.newNote;
        newNote.color = color;
        this.setState({newNote: newNote});
    };

    render() {
        const { newNote, notes } = this.state;
        return (
            <body>
            <Header/>
            <NoteForm
                newNote={newNote}
                handleInput={this.handleInputNewNote}
                handleClickColor={this.handleClickNewNoteColor}
                handleReset={this.handleResetNewNote}
                handleSubmit={this.handleSubmitNewNote}
            />
            <Notes appearances={"EDITABLE"}
                   notes={notes}
                   newNote={newNote}
                   handleClick={this.handleClick}
                   handleInput={this.handleInputForm}
                   handleClickColor={this.handleClickNoteColor}
                   handleDeleteNote={this.handleDeleteNote}
                   handleResetNote={this.handleResetNote}
                   handleSubmitNote={this.handleSubmitNote}
            />
            </body>
        );
    }

}

export default Layout;
